<nav class="navbar navbar-expand-lg navbar-light bg-dark">
  <div class="container">
    <a class="navbar-brand text-light" [routerLink]="['/']">GITHUB USER SEARCH</a>
  </div>
</nav>